<template>
  <router-view />
</template>

<script>
import { unRegisterMixin } from '@/mixin/storeGenerator';

export default {
  name: 'WrapperVocationalRehabilitationReferral',
  mixins: [unRegisterMixin],
  data() {
    return {
      moduleName: 'VocationalRehabilitationReferralModule',
    };
  },
};
</script>
